import { APP_CONFIG } from './app';
/**
 * @returns true if the environment is local development.
 */
export const isLocalEnvironment = () => {
    return APP_CONFIG.environment === 'local';
};
/**
 * @returns true if the environment is production.
 */
export const isProductionEnvironment = () => {
    return APP_CONFIG.environment === 'prod';
};
